import CenteredHeaderLayout from './classic/CenteredHeaderLayout';
import RightAlignedHeaderLayout from './classic/RightAlignedHeaderLayout';
import LeftAlignedHeaderLayout from './classic/LeftAlignedHeaderLayout';
import SidebarLeftLayout from './sidebar/SidebarLeftLayout';
import SidebarRightLayout from './sidebar/SidebarRightLayout';
// --- Topbar Layouts ---
import TopbarLeftLayout from './topbar/TopbarLeftLayout';
import TopbarRightLayout from './topbar/TopbarRightLayout';
import TopbarCenteredLayout from './topbar/TopbarCenteredLayout';

// Import icons for fallbacks (use correct names)
import ViewAgenda from '@mui/icons-material/ViewAgenda';
import ViewWeek from '@mui/icons-material/ViewWeek';
import ViewSidebar from '@mui/icons-material/ViewSidebar';
import ViewQuilt from '@mui/icons-material/ViewQuilt';
// Topbar icons
import ViewColumn from '@mui/icons-material/ViewColumn';
import ViewStream from '@mui/icons-material/ViewStream';
import ViewHeadline from '@mui/icons-material/ViewHeadline';

// Registry of all available layouts
const LAYOUTS = {
  'centered-header': {
    id: 'centered-header',
    name: 'Centered Title',
    description: 'Professional layout with centered header',
    category: 'Classic',
    component: CenteredHeaderLayout,
    // Add thumbnail info
    thumbnailPath: 'centered-header-layout-thumbnail.svg',
    fallbackIcon: ViewAgenda
  },
  'right-aligned-header': {
    id: 'right-aligned-header',
    name: 'Right-Aligned Title',
    description: 'Modern layout with right-aligned header',
    category: 'Classic',
    component: RightAlignedHeaderLayout,
    thumbnailPath: 'right-aligned-header-layout-thumbnail.svg',
    fallbackIcon: ViewWeek
  },
  'left-aligned-header': {
    id: 'left-aligned-header',
    name: 'Left-Aligned Title',
    description: 'Modern layout with left-aligned header',
    category: 'Classic',
    component: LeftAlignedHeaderLayout,
    thumbnailPath: 'left-aligned-header-layout-thumbnail.svg',
    fallbackIcon: ViewWeek,
    fallbackIconProps: { sx: { transform: 'scaleX(-1)' } } // Special props for transformed icons
  },
  'sidebar-left': {
    id: 'sidebar-left',
    name: 'Sidebar Left',
    description: 'Layout with skills and contact in left sidebar',
    category: 'Sidebar',
    component: SidebarLeftLayout,
    thumbnailPath: 'sidebar-left-layout-thumbnail.svg',
    fallbackIcon: ViewSidebar
  },
  'sidebar-right': {
    id: 'sidebar-right',
    name: 'Sidebar Right',
    description: 'Layout with skills and contact in right sidebar',
    category: 'Sidebar',
    component: SidebarRightLayout,
    thumbnailPath: 'sidebar-right-layout-thumbnail.svg',
    fallbackIcon: ViewQuilt
  },
  // --- Topbar Layouts ---
  'topbar-centered': {
    id: 'topbar-centered',
    name: 'Centered Title',
    description: 'Layout with skills and contact in a topbar aligned center',
    category: 'Topbar',
    component: TopbarCenteredLayout,
    thumbnailPath: 'topbar-centered-layout-thumbnail.svg',
    fallbackIcon: ViewHeadline
  },
  'topbar-right': {
    id: 'topbar-right',
    name: 'Right-Aligned Title',
    description: 'Layout with skills and contact in a topbar aligned right',
    category: 'Topbar',
    component: TopbarRightLayout,
    thumbnailPath: 'topbar-right-layout-thumbnail.svg',
    fallbackIcon: ViewStream
  },
  'topbar-left': {
    id: 'topbar-left',
    name: 'Left-Aligned Title',
    description: 'Layout with skills and contact in a topbar aligned left',
    category: 'Topbar',
    component: TopbarLeftLayout,
    thumbnailPath: 'topbar-left-layout-thumbnail.svg',
    fallbackIcon: ViewColumn
  },
};

// Get all layouts as an array with their metadata
export const getAllLayouts = () => {
  return Object.values(LAYOUTS);
};

// Get a specific layout by ID
export const getLayoutById = (id) => {
  return LAYOUTS[id] || LAYOUTS['centered-header']; // Default to centered header
};

// Get just the component for a layout ID
export const getLayoutComponent = (id) => {
  const layout = getLayoutById(id);
  return layout.component;
};

// Default layout ID
export const DEFAULT_LAYOUT_ID = 'centered-header';

// Helper function to get translated layout names
export const getTranslatedLayoutName = (layoutName, t) => {
  return t(`layoutNames.${layoutName}`) || layoutName;
};

// Helper function to get translated layout category
export const getTranslatedLayoutCategory = (category, t) => {
  return t(`layoutNames.${category}`) || category;
};

// Helper function to get translated layout description
export const getTranslatedLayoutDescription = (layoutId, t) => {
  return t(`layoutNames.descriptions.${layoutId}`) || LAYOUTS[layoutId]?.description;
};

export default {
  getAllLayouts,
  getLayoutById,
  getLayoutComponent,
  DEFAULT_LAYOUT_ID,
  LAYOUTS,
  getTranslatedLayoutName,
  getTranslatedLayoutCategory,
  getTranslatedLayoutDescription
}; 